(function () { if (!LN.Core || !LN.Config) throw new Error("LN.Core || LN.Config missing"); })();

(function (Controller, Config, Helper, Service, Handler, Model, Message, $) {
    'use strict';

    Controller.validarTipoAsociacionClub = function () {
        Helper.updateToken();
        Service.ajaxPost('/Usuario/ObtenerDatosClub', false, function (res, status, xhr) {
            Handler.obtenerDatosClubHandler(res, status, xhr);
        }, null, {
            sentHeader: true
        });
    }

    Controller.asociarCredencialView = function (error, tipoError) {
        var modoBlack = (Model.Window.modo == "V" || Model.Window.modo == "B") ? true : false;
        Helper.callView('ASOCIAR_TARJETA', {
            modoBlack: modoBlack,
            modoPremium: !modoBlack,
            mode: Model.Window.modo,
            code: Model.Usuario.TipoAsociarCredencial,
            error: error,
            tipoError: tipoError
        }, Controller.asociarCredencialBindings, true);
    }

    Controller.asociarCredencialBindings = function () {
        $(".num-cred").autotab();
        $('select').niceSelect();

        if (Model.Window.modo == "B") $("main").addClass("black-default");

        $(document).on("keypress", "#nro-credencial-1, #nro-credencial-2, #nro-credencial-3", function (e) {
            // Solo permito ingresar numero y enter . 
            var keycode = event.which;
            if (!(event.shiftKey == false && (keycode == 13 || (keycode >= 48 && keycode <= 57)))) {
                e.preventDefault();
            }
        })

        $(document).on("keyup focusout", "#nro-credencial-1", function () {
            if ($(this).val() === '') Helper.cleanStatus($(this));
            else if (Helper.Validators.credencialClub1.test($(this).val()) && $(this).val() !== '') Helper.changeStatus($(this), true);
            else Helper.changeStatus($(this), false);
        })

        $(document).on("keyup focusout", "#nro-credencial-2", function () {
            if ($(this).val() === '') Helper.cleanStatus($(this));
            else if (Helper.Validators.credencialClub2.test($(this).val()) && $(this).val() !== '') Helper.changeStatus($(this), true);
            else Helper.changeStatus($(this), false);
        })

        $(document).on("keyup focusout", "#nro-credencial-3", function () {
            if ($(this).val() === '') Helper.cleanStatus($(this));
            else if (Helper.Validators.credencialClub3.test($(this).val()) && $(this).val() !== '') Helper.changeStatus($(this), true);
            else Helper.changeStatus($(this), false);
        })

        $(document).on('keypress', '#nro-documento', function (e) {
            var optionSelected = $("#tipo-documento option:selected").data('validator');
            if (this.value.length >= Helper.Validators.Max[optionSelected]) return false;
        });

        $(document).on('change', '#tipo-documento', function (e) {
            var optionSelected = $("#tipo-documento option:selected").val();
            (optionSelected == 'PAS') ? $("#nro-documento").attr('type', 'text') : $("#nro-documento").attr('type', 'number');
        });

        // Eventos de popup credencial dos últimos números . 
        // TODO : ver si puede ir en formularios.js
        $("b.burbuja").click(function () {
            $(".burbuja-inner").toggle();
        });
        $(document).on("click", function (e) {
            if ($(e.target).is("b.burbuja, .burbuja-inner") === false) {
                $(".burbuja-inner").hide();
            }
        });

        // Dependiendo el modo y cantidad de credenciales levantadas cargo en inputs valor de credencial . 

        switch (Model.Usuario.TipoAsociarCredencial) {
            case "1":
                if (Model.Usuario.Credenciales.length == 1) {
                    var credencialAsociada = LN.Model.Usuario.Credenciales[0].nroTarjeta.replace(/-/gi, "");
                    $("#nro-credencial-1").prop("readonly", true).val(credencialAsociada.substring(0, 6));
                    Helper.changeStatus($("#nro-credencial-1"), true);
                    $("#nro-credencial-2").attr("type", "text").prop("readonly", true).val("XXXXXXXX");
                    Helper.changeStatus($("#nro-credencial-2"), true);
                    $("#nro-credencial-3").focus().click();
                    $(".nro-credencial").removeClass("completa");
                    $("#asociar_tarjeta").addClass("cargado");
                }
                break;
            case "2":
                $("#nro-documento").focus().click();
                break;
        }
    }

    Controller.buscarCredencial = function (credencial) {
        var crm = null;
        $(Model.Usuario.Credenciales).each(function () {
            if (this.nroTarjeta.replace(/-/gi, "") == credencial) crm = this.CrmId;
        })
        return crm;
    }

    Controller.asociarCrendecialValidaciones = function () {

        var credencial1 = $("#nro-credencial-1");
        var credencial2 = $("#nro-credencial-2");
        var credencial3 = $("#nro-credencial-3");
        var nroDocumento = $("#nro-documento");
        var tipoDocumentoValidacion = $("#tipo-documento option:selected").data('validator')

        var credencial = credencial1.val() + credencial2.val() + credencial3.val();
        var cantInputs = (nroDocumento.length > 0) ? 2 : 1;
        var cantInputsOk = 0;

        // Validación nro de credencial 
        var bStatusCred1 = Helper.Validators.credencialClub1.test(credencial1.val());
        var bStatusCred2 = Helper.Validators.credencialClub2.test(credencial2.val());
        var bStatusCred3 = Helper.Validators.credencialClub3.test(credencial3.val());
        Helper.changeStatus(credencial1, bStatusCred1);
        Helper.changeStatus(credencial2, bStatusCred2);
        Helper.changeStatus(credencial3, bStatusCred3);

        var credencialErrorMensaje = $("#credencial-error");
        if (!bStatusCred1 || !bStatusCred2 || !bStatusCred3) credencialErrorMensaje.html(Message.Credencial['INCORRECTA']);
        else credencialErrorMensaje.html('');

        if (bStatusCred1 && bStatusCred2 && bStatusCred3) {
            if (Model.Usuario.Credenciales.length == 1 && Model.Usuario.TipoAsociarCredencial == "1") { // Caso de asociación rápida (solo ingreso los dos últimos dígitos)
                cantInputsOk++;
                Model.Usuario.Credencial = Model.Usuario.Credenciales[0].nroTarjeta.replace(/-/gi, "").substr(0, 14) + credencial3.val();
            } else if (Helper.Validators.credencialClub.test(credencial)) {
                cantInputsOk++;
                Model.Usuario.Credencial = credencial;
            }
        }

        // Validación nro de documento 
        if (nroDocumento.length > 0) {
            if (nroDocumento.val() != "" && Helper.Validators[tipoDocumentoValidacion].test(nroDocumento.val())) {
                cantInputsOk++;
                Helper.changeStatus(nroDocumento, true);
            } else {
              Helper.changeStatus(nroDocumento, false, Message.Credencial['DNI_INCOMPLETO'], Message.Analytics.Credencial['DNI_INCOMPLETO'] );
            }
        }
        return cantInputs === cantInputsOk;
    }

    Controller.asociarCredencialCall = function (data) {
        Helper.updateToken();
        Service.ajaxPost('/Usuario/AsociarCredencial', data, function (res, status, xhr) {
            Handler.asociarResponseHandler(res, status, xhr);
        }, null, {
            sentHeader: true,
            showPreloader: true
        });
    }

    // Asociación directa . Tengo que autocompletar nro-crendencial-1 y nro-credencial-2, hacer que el usuario complete nro-credencial-3 (para caso 1 ) 
    // Para caso 3 tengo que completar la credencial completa . 
    // Tengo en memoria crm y nro-credencial . Voy al servicio con usuario-id y crm . 
    Controller.asociarCredencialCorto = function () {
        if (Controller.asociarCrendecialValidaciones()) {
            if (Controller.buscarCredencial(Model.Usuario.Credencial) === null) {
                // Le erró al ingresar la credencial y redirige al ingreso de DNI - Credencial . 
                Model.Usuario.TipoAsociarCredencial = "2";
                Controller.asociarCredencialView();
            } else {
                var data = {
                    crmId: Controller.buscarCredencial(Model.Usuario.Credencial),
                    estado: (Model.Usuario.Credenciales.length == 1) ? 1 : 2
                }
                Controller.asociarCredencialCall(data);
            }
        }
    }

    // Asociación largo . Tengo que completar nro-credencial y nro-documento . 
    Controller.asociarCredencialLargo = function () {
        if (Controller.asociarCrendecialValidaciones()) {
            var data = {
                tipo_doc: $("#tipo-documento").val(),
                nro_doc: $("#nro-documento").val(),
                nro_tarjeta: Model.Usuario.Credencial
            };
            Controller.asociarCredencialCall(data);
        }
    }

    Controller.finalizarAsociar = function () {

        Service.ajaxPost('/Usuario/Me', false, function (res, status, xhr) {
            if (!Helper.isEmpty(res.response)) {
                var usuario = JSON.parse(res.response);
                Model.Usuario.ClubNacion = (usuario.Usuario.ClubNacion === undefined) ? "" : usuario.Usuario.ClubNacion;
                Helper.setupCookies(usuario.Usuario);

                // TODO . 
                if (Model.Window.modo == "B" || Model.Window.modo == "V") {
                    Controller.validarCredencialBlack();            // Tengo que validar si la credencial asociada es Black . 
                }
                else Helper.returnBack();   // Circuito solo de asociación . Tengo que redirigir a url callback .
            }
        }, null, {
            sentHeader: true
        });

    }
})(LN.Controller, LN.Config, LN.Helper, LN.Service, LN.Handler, LN.Model, LN.Message, jQuery);


// WEBPACK FOOTER //
// ./Statics/scripts/login/controllers/credencial.js